import { render, staticRenderFns } from "./SuppliersMain.vue?vue&type=template&id=38b415ab&scoped=true&"
import script from "./SuppliersMain.vue?vue&type=script&lang=js&"
export * from "./SuppliersMain.vue?vue&type=script&lang=js&"
import style0 from "./SuppliersMain.vue?vue&type=style&index=0&id=38b415ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b415ab",
  null
  
)

export default component.exports